import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import {FormBuilder, FormGroup} from "@angular/forms";

declare let $: any;
declare let Swal: any;

@Component({
    selector : 'notify',
    templateUrl:'notify-component.html'
})
export class NotifyComponent implements OnInit, OnDestroy{

  public notifyForm : FormGroup;
  public tab=1;

  public constructor( private _router : Router,private fb : FormBuilder,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public setTab(t){
    this.tab=t;
  }
  public ngOnInit(): any {
    this.notifyForm = this.fb.group({
      subject : '',
      text : '',
      video : ''
    });
  }


  
  public notify() {
    let subject : string      = this.notifyForm.controls['subject'].value;
    let text : string      = this.notifyForm.controls['text'].value;
    let video : string = this.notifyForm.controls['video'].value;

    let date=new Date();
    let time=date.getTime();
    let notification;
    if (!video){
      notification={
        subject:subject,
        message:text,
        kind:'text',
        date:time
      }
    }else{
      notification={
        subject:subject,
        video:video,
        kind:'video',
        date:time
      }
    }
    this._companyService.addRoomNotification(this._appData.room,notification);
    this.notifyForm = this.fb.group({
      subject : '',
      text : '',
      video : ''
    });


  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
  }

  public ngOnDestroy() : any {

  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/notify/notify-component.ts